export default "__VITE_ASSET__DPrp71kE__"